import styled from 'styled-components'

import { media } from 'styles/media'
import typeStyle from 'styles/typeStyle'

// import ShowMoreText from '../../ShowMoreText'
import LazyImage from '../../../components/display/LazyImage'
import Avatar from '../../../components/display/Avatar'

import type { Member } from './types'

const Wrapper = styled.div`
  text-align: center;

  ${Avatar} {
    display: inline-block;
    width: 100px;
    height: 100px;
    margin: 0;
    margin-bottom: 8px;

    ${media.md`
      width: 140px;
      height: 140px;
    `}
  }
`

// const Content = styled.div`
// `

const Name = styled.h5`
  ${typeStyle('-ds-font-title-3-regular')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  margin-bottom: 8px;
`

const Position = styled.h6`
  ${typeStyle('-ds-font-body-light')}
  color: ${({ theme }) => theme?.['-ds-neutral-700']?.value};
  margin-bottom: 16px;
`

export default ({ image, name, position }: Member) => (
  <Wrapper>
    <Avatar>
      <LazyImage data-src={image} alt={name} preload />
    </Avatar>

    <Name>{name}</Name>
    <Position>{position}</Position>

    {/* <Content>
      <ShowMoreText lines={3} inline>
        {bio}
      </ShowMoreText>
    </Content> */}
  </Wrapper>
)
